import React from "react";
//*import PropTypes from 'prop-types';
import "./voicemailSkeletonTop.scss";
import { URAvaratSkeleton } from "./skeletonWidgets/avatar";
import { URLineSkeleton } from "./skeletonWidgets/lineSkeleton";
import { URButtonSkeleton } from "./skeletonWidgets/buttonSkeleton";
import { initiateCall } from "../../base/callService/callService";
import { ChatService } from "../../base/chatService";

type skeltoneProps={
  particularLog:any;
  history:any;
}
function URvoicemailSkeletonTop({particularLog,history}:skeltoneProps) {
  return (
    <>
      <div className="voicemailSkeleton">
        <div className="profileDesc">
          <URAvaratSkeleton className='avatar lg'/>
        </div>
        <div className="avtrDesc"><URLineSkeleton className='line lineThick size50'/></div>
        {/* <div className="buttonList">
          <URButtonSkeleton className='skeletonBtn' />
          <URButtonSkeleton className='skeletonBtn' />
          <URButtonSkeleton className='skeletonBtn' />
        </div> */}
      {particularLog?.sip_login_id ?
        <div className='skeltoneAction' >
            <div className='callIcon' onClick={() => initiateCall(particularLog?.ext, 'audio')}>
              <span></span> Call</div>
          <div className='chatIcon'
              onClick={() => ChatService.openChatWindow(particularLog, history)} ><span></span> Chat</div>
          <div className='meetIcon'><span></span> Meet</div>
      </div>
      :
        <div className="buttonList">
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
          <URButtonSkeleton className='skeletonBtn' />
          <URLineSkeleton className='line lineThick size10'/>
        </div> 
    }
      </div>
    </>

  );
}

export {
  URvoicemailSkeletonTop
};